import { Action } from '../../../redux/redux.types';

import { FILE_MANAGER_ACTIONS } from './file-manager.actions';

export interface DeleteFilesModalState {
  isDeleteModalOpened: boolean;
}

const defaultState: DeleteFilesModalState = {
  isDeleteModalOpened: false,
};

export const deleteFilesModal = (
  state: DeleteFilesModalState = defaultState,
  { type }: Action<undefined>,
): DeleteFilesModalState => {
  switch (type) {
    case FILE_MANAGER_ACTIONS.OPEN_DELETE_MODAL:
      return {
        isDeleteModalOpened: true,
      };
    case FILE_MANAGER_ACTIONS.CLOSE_DELETE_MODAL:
      return {
        isDeleteModalOpened: false,
      };
    default:
      return state;
  }
};
